import React from "react";
import PropTypes from "prop-types";
import {connect} from "react-redux";
import PopupWrapper from "@mnjsplatform/components/lib/common/PopupWrapper";
import ComplexParam from "@mnjsplatform/components/lib/common/ComplexParam";
import i18next from "i18next";
import CompanyFindForm from "./CompanyFindForm";
import {Link} from "react-router-dom";
import TruckOwnCompanyFindForm from "./TruckOwnCompanyFindForm";
import UrProvider from "@mnjsplatform/data/lib/api/UrProvider";

const transportationTypes = {
  own: "1",
  attracted: "2"
};

const contractSignedTypes = {
  yes: "1",
  no: "2"
};

const isDetailTypes = {
  yes: "1",
  no: "2"
};

const reqReqiredOwnTypes = ["3","4","5"];

class WaybillForm extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      isCompanyFindFormVisible: false,
      isTruckOwnCompanyFindFormVisible: false,
    };
  }

  componentDidMount() {
    this.init();
  }

  init = async() => {
    await this.props.dispatch(this.props.transportReqSetSWInfo.reset());
    await this.props.dispatch(this.props.transportReqSetSWInfo.initialize(this.props.row, {
      withParams: true,
      refresh: false,
      newItem: true
    }));
    await this.props.dispatch(this.props.transportReqGetSWInfoMessages.execute({}, {withParams: false}));
  };

  getTransportationTypeId = () => this.props.transportReqSetSWInfoParams.getField(0, "SWTransportationTypeId");
  getContractSigned = () => this.props.transportReqSetSWInfoParams.getField(0, "SWContractSignedId");
  getWarningMessage = () => this.props.transportReqGetSWInfoMessages.getField(0, "WarningSWContractSignedId2");
  getETRNWarningMessage = () => this.props.transportReqGetSWInfoMessages.getField(0, "WarningIsRequiredETRN");
  getOwnTypeId = () => this.props.transportReqSetSWInfoParams.getField(0, "SWTruckOwnTypeId");
  getIsDetail = () => this.props.transportReqSetSWInfoParams.getField(0, "SWDriverIsDetail");

  getVisibleFields = () => {
    const fields = ["SWTransportationTypeName"];
    const transportationTypeId = this.getTransportationTypeId();
    const ownTypeId = this.getOwnTypeId();

    if (transportationTypeId === transportationTypes.own) {
      fields.push("SWTruckOwnTypeName");

      if (reqReqiredOwnTypes.includes(ownTypeId)) {
        fields.push("SWDocConfirmOwnVehicle");
      }

      fields.push("SWTruckOwnExchName")
      fields.push("SWDriverIsDetailName")

      if (this.getIsDetail() === isDetailTypes.yes) {
        fields.push("SWDriverDetailText")
      }

      fields.push(
          "SWAutoTypeName",
          //"SWAdvAutoTypeName",
          "SWAutoTypeLoad",
          "SWAutoTypeCargo",

          "SWAddAutoTypeName",
          "SWAdvAddAutoTypeName",
          "SWAddAutoTypeLoad",
          "SWAddAutoTypeCargo"
      )
    } else if (transportationTypeId === transportationTypes.attracted) {
      fields.push("SWContractSignedName");
      const contractSigned = this.getContractSigned();
      if (contractSigned === contractSignedTypes.yes) {
        fields.push(
          "SWContractForwarderCarrier",
          "SWTruckOwnTypeName",
          "SWTruckOwnDriverCompanyId",
          "SWTruckOwnName",

        );

        if (reqReqiredOwnTypes.includes(ownTypeId)) {
          fields.push("SWDocConfirmOwnVehicle");
        }

        fields.push(
            "SWTruckOwnTaxCode",
            "SWTruckOwnLegalAddress",
            "SWTruckOwnPhoneNumber",
            "SWTruckOwnExchName",
        )

        fields.push("SWDriverIsDetailName")
        if (this.getIsDetail() === isDetailTypes.yes) {
          fields.push("SWDriverDetailText")
        }

        fields.push(
            "SWAutoTypeName",
            //"SWAdvAutoTypeName",
            "SWAutoTypeLoad",
            "SWAutoTypeCargo",

            "SWAddAutoTypeName",
            "SWAdvAddAutoTypeName",
            "SWAddAutoTypeLoad",
            "SWAddAutoTypeCargo"
        )
      }
    }

    return fields;
  };

  onSave = async() => {
    await this.props.dispatch(this.props.transportReqSetSWInfo.applyParams(this.props.transportReqSetSWInfoParams));
    if (!this.props.transportReqSetSWInfo.isError) {
      this.props.onSave();
    }
  };

  onEndEditField = async(rowIndex, fieldDescriptor, forceApplyParams) => {
    if (fieldDescriptor.fieldInfo.Name === "SWContractSignedName") {
      const value = this.props.transportReqSetSWInfoParams.getField(0, "SWContractSignedId");
      /*if (value === contractSignedTypes.no && !this.props.transportReqGetSWInfoMessages.isInitialized) {
        await this.props.dispatch(this.props.transportReqGetSWInfoMessages.execute({}, {withParams: false}));
      }*/
    }
  };

  onClean = async ()=> {
    await this.props.dispatch(this.props.transportReqSWInfoClear.execute({}, {withParams: false}));
    await this.props.dispatch(this.props.transportReqSetSWInfoParams.setFields(0, this.props.transportReqSWInfoClear.getRow(0)));
  }

  onPasteData = async() => {
    await this.props.dispatch(this.props.transportReqSetSWInfoParams.setFields(0, this.props.getBufferData()));
  };

  showFindForm = () => {
    this.setState({isCompanyFindFormVisible: true});
  };

  hideFindForm = () => {
    this.setState({isCompanyFindFormVisible: false});
  };

  showTruckOwnCompanyFindForm = async () => {
    this.setState({isTruckOwnCompanyFindFormVisible: true});

    /*let fields = {SWTruckOwnDriverCompanyExchLineNumber: 0, SWTruckOwnDriverCompanyExchTypeId: "vgbre434", SWTruckOwnDriverCompanyId: "grewq3"}
    await this.props.dispatch(this.props.transportReqSetSWInfoParams.setFields(0, fields));
    this.hideTruckOwnCompanyFindForm();*/
  }

  hideTruckOwnCompanyFindForm = () => {
    this.setState({isTruckOwnCompanyFindFormVisible: false});
  }

  onSelectCompany = async(fields) => {
    await this.props.dispatch(this.props.transportReqSetSWInfoParams.setFields(0, fields));
    this.hideFindForm();
  };

  onSelectTruckOwnCompanyFindForm = async (fields) => {
    if(this.props.transportReqSetSWInfoParams.rawData.ColumnUpdateRules["SWTruckOwnDriverCompanyId"])
    {
      let newFields = {};
      const urProcessed = this.props.transportReqSetSWInfoParams.rawData.ColumnUpdateRules["SWTruckOwnDriverCompanyId"];
      const urProvider = new UrProvider(urProcessed);

      if(urProvider.updateRules.length > 0) {
        for (let ri of urProvider.updateRules)
          newFields[ri.strDst] = fields[ri.strSrc];

        fields = newFields;
      }
    }

    await this.props.dispatch(this.props.transportReqSetSWInfoParams.setFields(0, fields));
    this.hideTruckOwnCompanyFindForm();
  }

  renderParamsRow = (h, fieldName) => {

    if(fieldName === "SWTruckOwnDriverCompanyId") {
      return (
          <div key={fieldName} className="row mb-1">
            <div className="col-md-3 field-title">
              &nbsp;
            </div>
            <div className="col-md-9">
              <button className="btn mn-btn-link" onClick={() => this.showTruckOwnCompanyFindForm()}>
                {h.lbl(fieldName)}
              </button>
            </div>
          </div>
      )
    }

    return (
        <div key={fieldName} className="row mb-1">
        <div className="col-md-3 field-title">
          {h.lbl(fieldName)}
        </div>
        <div className="col-md-9">
          {h.ed(fieldName)}
        </div>
      </div>
    );
  };

  renderWarningMessage = () => {
    return (
      <div style={{color: "red"}}>
        {this.getWarningMessage()}
      </div>
    );
  };

  renderParams = (h) => {
    const visibleFields = this.getVisibleFields();
    const showWarningMessage = this.getTransportationTypeId() === transportationTypes.attracted && this.getContractSigned() === contractSignedTypes.no;
    return (
      <div>
        {visibleFields.map((fieldName => this.renderParamsRow(h, fieldName)))}
        {showWarningMessage && this.renderWarningMessage()}
      </div>
    );
  };

  renderButtons = () => {
    const showCopyRequisitesButton = this.getTransportationTypeId() === transportationTypes.attracted && this.getContractSigned() === contractSignedTypes.yes;
    const showPasteButton = !!this.props.getBufferData();
    return (
      <div className="modal-footer text-right">
        <div className="text-right">
          {showCopyRequisitesButton &&
          <button className="btn btn-regular float-left"
                  onClick={this.showFindForm}
          >
            {i18next.t("CopyRequisites")}
          </button>
          }
          {showPasteButton &&
          <button className="btn btn-regular mr-md-1"
                  onClick={this.onPasteData}>
            {i18next.t('PasteData')}
          </button>
          }
          <button className="btn btn-regular mr-md-1"
                  onClick={this.onClean}>
            {i18next.t('Clean')}
          </button>
          <button className="btn btn-regular mr-md-1"
                  onClick={this.onSave}>
            {i18next.t('Save')}
          </button>
          <button className="btn btn-regular"
                  onClick={this.props.onClose}>
            {i18next.t('Cancel')}
          </button>
        </div>
      </div>
    );
  };

  renderCompanyFindForm = () => {
    if (!this.state.isCompanyFindFormVisible) {
      return null;
    }
    return (
      <CompanyFindForm row={this.props.row}
                       onClose={this.hideFindForm}
                       onSelect={this.onSelectCompany}
      />
    );
  };

  renderTruckOwnCompanyFindForm = () => {
    return (
        <TruckOwnCompanyFindForm popupVisible={this.state.isTruckOwnCompanyFindFormVisible}
                                 onClose={this.hideTruckOwnCompanyFindForm}
                                 onSelect={this.onSelectTruckOwnCompanyFindForm}
                                 title="Выбор компании Перевозчика"
        />
    );
  }

  render() {
    if (!this.props.transportReqSetSWInfo.isInitialized) {
      return null;
    }

    const showCustETRNWarning = !!this.props.row.IsCustETRN;
    const msg = this.getETRNWarningMessage();

    return (
      <>
        <PopupWrapper popupVisible
                      onClose={this.props.onClose}
                      title={i18next.t("WaybillFormTitle")}
                      renderButtons={this.renderButtons}
        >
          {showCustETRNWarning &&
              <div className="row mb-1">
                <div className="col-md-12">
                  <span className="antipod">{msg}</span>
                </div>
              </div>
          }
          <ComplexParam dataItem={this.props.transportReqSetSWInfoParams}
                        rowIndex={0}
                        showSearchBar={false}
                        showApplyButton={false}
                        renderParams={this.renderParams}
                        onEndEditField={this.onEndEditField}
          />
        </PopupWrapper>
        {this.renderCompanyFindForm()}
        {this.renderTruckOwnCompanyFindForm()}
      </>
    );
  }
}

WaybillForm.propTypes = {
  dispatch: PropTypes.func,
  transportReqSetSWInfo: PropTypes.object,
  transportReqSetSWInfoParams: PropTypes.object,
  transportReqGetSWInfoMessages: PropTypes.object,
  row: PropTypes.object.isRequired,
  onSave: PropTypes.func.isRequired,
  onClose: PropTypes.func.isRequired,
  getBufferData: PropTypes.func
};

const mapStateToProps = (state, ownProps) => {
  return {
    transportReqSetSWInfo: state.transportState.transportReqSetSWInfo,
    transportReqSetSWInfoParams: state.transportState.transportReqSetSWInfoParams,
    transportReqGetSWInfoMessages: state.transportState.transportReqGetSWInfoMessages,
    transportReqSWInfoClear: state.transportState.transportReqSWInfoClear
  };
};

export default connect(mapStateToProps)(WaybillForm);